let frontendHost = 'http://localhost:3000';
let backendHost = 'http://localhost:5000';

const hostname = window && window.location && window.location.hostname;
const testPriceId = 'price_1Kn4B9HpceaN4ofn1VSbvZ65';
const prodPriceId = 'price_1Kn35iHpceaN4ofnWg5JCDrK';
let surveyPriceId = testPriceId;

if (hostname === 'pondera-ui.azurewebsites.net') {
  frontendHost = 'https://pondera-ui.azurewebsites.net';
  backendHost = 'https://pondera-api.azurewebsites.net';
} else if (hostname === 'pondera-ui-dev.azurewebsites.net') {
  frontendHost = 'https://pondera-ui-dev.azurewebsites.net';
  backendHost = 'https://pondera-api-dev.azurewebsites.net';
} else if (hostname === 'pondera-ui-prod.azurewebsites.net') {
  frontendHost = 'https://pondera-ui-prod.azurewebsites.net';
  backendHost = 'https://pondera-api-prod.azurewebsites.net';
  surveyPriceId = prodPriceId;
} else if (hostname === 'ponderavirtualadvisor.com') {
  frontendHost = 'https://ponderavirtualadvisor.com';
  backendHost = 'https://pondera-api.azurewebsites.net';
  surveyPriceId = prodPriceId;
} else {
  frontendHost = `http://${window.location.host}`;
}

console.log('frontend host:', frontendHost);
console.log('backend host:', backendHost);

export const BACKEND_ROOT = backendHost;
export const FRONTEND_ROOT = frontendHost;
export const SURVEY_PRICE_ID = surveyPriceId;


// WEBPACK FOOTER //
// ./src/config/host-config.tsx